webpackJsonp([47],{

/***/ 1320:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ActivityList__ = __webpack_require__(1558);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ActivityList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__ActivityList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__LoginUser__ = __webpack_require__(1559);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__LoginUser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__LoginUser__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




function activeActivitiesTab() {
	return this.activeTab === 'tab-2';
}

function activeLoginTab() {
	return this.activeTab === 'tab-1';
}

function data() {
	return {
		activeTab: 'tab-1',
		tabs: [{ id: 1, title: 'Log-in' }, { id: 2, title: 'Actividades' }]
	};
}

/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'activities',
	components: {
		ActivityList: __WEBPACK_IMPORTED_MODULE_0__ActivityList___default.a,
		LoginUser: __WEBPACK_IMPORTED_MODULE_1__LoginUser___default.a
	},
	computed: {
		activeActivitiesTab: activeActivitiesTab,
		activeLoginTab: activeLoginTab
	},
	data: data
});

/***/ }),

/***/ 1321:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_table_run__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_table_run___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_table_run__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__clerkinn_shared_select_date__ = __webpack_require__(922);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__clerkinn_shared_select_date___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__clerkinn_shared_select_date__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__clerkinn_shared_select_button__ = __webpack_require__(920);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__clerkinn_shared_select_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__clerkinn_shared_select_button__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





function loadData() {}

function pagesVisible() {
	return this.totalPages < 5 ? this.totalPages : 5;
}

function data() {
	return {
		actions: [],
		activeTab: 'tab-1',
		columns: [{ id: 1, name: 'Fecha', code: 'date', isSortable: { down: true, up: false } }, { id: 2, name: 'Hora', code: 'hour', isSortable: { down: true, up: false } }, { id: 3, name: 'Dispositivo', code: 'device', isSortable: { down: true, up: false } }, { id: 4, name: 'Dirección IP', code: 'ip', isSortable: { down: true, up: false } }, { id: 5, name: 'Acción', code: 'action', isSortable: { down: true, up: false } }, { id: 6, name: 'Actividad', code: 'activity', isSortable: { down: true, up: false } }],
		params: {
			dateEnd: '',
			dateInit: '',
			page: 1,
			perPage: 20,
			search: null,
			flagActive: null
		},
		rows: [{
			date: '2018/10/16',
			hour: '14:22',
			device: 'Mackbook Pro',
			ip: '192.168.0.5',
			action: 'Crear',
			activity: 'Reserva 28/05'
		}],
		totalPages: null
	};
}

/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'activity-list',
	components: {
		TableRun: __WEBPACK_IMPORTED_MODULE_0_table_run___default.a,
		selectButton: __WEBPACK_IMPORTED_MODULE_2__clerkinn_shared_select_button___default.a,
		selectDate: __WEBPACK_IMPORTED_MODULE_1__clerkinn_shared_select_date___default.a
	},
	computed: {
		pagesVisible: pagesVisible
	},
	data: data,
	methods: {
		loadData: loadData
	}
});

/***/ }),

/***/ 1323:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_table_run__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_table_run___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_table_run__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__clerkinn_shared_select_date__ = __webpack_require__(922);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__clerkinn_shared_select_date___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__clerkinn_shared_select_date__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__clerkinn_shared_select_button__ = __webpack_require__(920);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__clerkinn_shared_select_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__clerkinn_shared_select_button__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





function loadData() {}

function pagesVisible() {
	return this.totalPages < 5 ? this.totalPages : 5;
}

function data() {
	return {
		activeTab: 'tab-1',
		columns: [{ id: 1, name: 'Fecha', code: 'date', isSortable: { down: true, up: false } }, { id: 2, name: 'Hora', code: 'hour', isSortable: { down: true, up: false } }, { id: 3, name: 'Dispositivo', code: 'device', isSortable: { down: true, up: false } }, { id: 4, name: 'Dirección IP', code: 'ip', isSortable: { down: true, up: false } }, { id: 5, name: 'Ubicación', code: 'location', isSortable: { down: true, up: false } }, { id: 6, name: 'Sucursal', code: 'subsidiary', isSortable: { down: true, up: false } }],
		params: {
			dateEnd: '',
			dateInit: '',
			page: 1,
			perPage: 20,
			search: null,
			flagActive: null
		},
		rows: [{
			date: '2018/10/16',
			hour: '14:22',
			device: 'Mackbook Pro',
			ip: '192.168.0.5',
			location: 'Perú',
			subsidiary: 'Lima'
		}],
		totalPages: null
	};
}

/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'user-login',
	components: {
		TableRun: __WEBPACK_IMPORTED_MODULE_0_table_run___default.a,
		selectButton: __WEBPACK_IMPORTED_MODULE_2__clerkinn_shared_select_button___default.a,
		selectDate: __WEBPACK_IMPORTED_MODULE_1__clerkinn_shared_select_date___default.a
	},
	computed: {
		pagesVisible: pagesVisible
	},
	data: data,
	methods: {
		loadData: loadData
	}
});

/***/ }),

/***/ 1558:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(1321),
  /* template */
  __webpack_require__(1650),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1559:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(1323),
  /* template */
  __webpack_require__(1645),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1643:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-tabs', {
    staticClass: "checkin-tabs pos-tabs-left",
    attrs: {
      "grow": ""
    },
    model: {
      value: (_vm.activeTab),
      callback: function($$v) {
        _vm.activeTab = $$v
      },
      expression: "activeTab"
    }
  }, [_c('v-tabs-bar', {
    staticClass: "transparent"
  }, [_c('v-tabs-slider', {
    staticClass: "default-skyblue"
  }), _vm._v(" "), _vm._l((_vm.tabs), function(tab) {
    return _c('v-tabs-item', {
      key: tab.id,
      attrs: {
        "href": ("#tab-" + (tab.id))
      }
    }, [_vm._v("\n\t\t\t\t" + _vm._s(tab.title) + "\n\t\t\t")])
  })], 2), _vm._v(" "), _c('v-tabs-items', _vm._l((_vm.tabs.length), function(i) {
    return _c('v-tabs-content', {
      key: i,
      attrs: {
        "id": ("tab-" + i)
      }
    }, [(_vm.activeActivitiesTab) ? _c('activity-list') : _vm._e(), _vm._v(" "), (_vm.activeLoginTab) ? _c('login-user') : _vm._e()], 1)
  }))], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1645:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-container', [_c('v-layout', [_c('v-flex', {
    attrs: {
      "xs5": "",
      "d-flex": "",
      "justify-start": "",
      "mr-3": ""
    }
  }, [_c('select-date', {
    attrs: {
      "placeholder": "Fecha de inicio",
      "icon": "event"
    },
    on: {
      "input": _vm.loadData
    },
    model: {
      value: (_vm.params.dateInit),
      callback: function($$v) {
        _vm.params.dateInit = $$v
      },
      expression: "params.dateInit"
    }
  }), _vm._v(" "), _c('select-date', {
    attrs: {
      "placeholder": "Fecha de fin"
    },
    on: {
      "input": _vm.loadData
    },
    model: {
      value: (_vm.params.dateEnd),
      callback: function($$v) {
        _vm.params.dateEnd = $$v
      },
      expression: "params.dateEnd"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', [_c('table-run', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.rows,
      "include-delete": false,
      "include-export-to-excel": false
    },
    scopedSlots: _vm._u([{
      key: "rows",
      fn: function(props) {
        return [_c('td', [_vm._v(_vm._s(props.row.date))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.hour))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.device))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.ip))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.location))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.subsidiary))])]
      }
    }])
  }), _vm._v(" "), _c('div', {
    staticClass: "text-xs-right mt-3"
  }, [_c('v-pagination', {
    attrs: {
      "length": _vm.totalPages,
      "total-visible": _vm.pagesVisible
    },
    on: {
      "input": _vm.loadData
    },
    model: {
      value: (_vm.params.page),
      callback: function($$v) {
        _vm.params.page = $$v
      },
      expression: "params.page"
    }
  })], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1650:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-container', [_c('v-layout', [_c('v-flex', {
    attrs: {
      "xs5": "",
      "d-flex": "",
      "justify-start": "",
      "mr-3": ""
    }
  }, [_c('select-date', {
    attrs: {
      "placeholder": "Fecha de inicio",
      "icon": "event"
    },
    on: {
      "input": _vm.loadData
    },
    model: {
      value: (_vm.params.dateInit),
      callback: function($$v) {
        _vm.params.dateInit = $$v
      },
      expression: "params.dateInit"
    }
  }), _vm._v(" "), _c('select-date', {
    attrs: {
      "placeholder": "Fecha de fin"
    },
    on: {
      "input": _vm.loadData
    },
    model: {
      value: (_vm.params.dateEnd),
      callback: function($$v) {
        _vm.params.dateEnd = $$v
      },
      expression: "params.dateEnd"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs2": ""
    }
  }, [_c('select-button', {
    attrs: {
      "placeholder": "Acción",
      "items": _vm.actions
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', [_c('table-run', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.rows,
      "include-delete": false,
      "include-export-to-excel": false
    },
    scopedSlots: _vm._u([{
      key: "rows",
      fn: function(props) {
        return [_c('td', [_vm._v(_vm._s(props.row.date))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.hour))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.device))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.ip))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.action))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.activity))])]
      }
    }])
  }), _vm._v(" "), _c('div', {
    staticClass: "text-xs-right mt-3"
  }, [_c('v-pagination', {
    attrs: {
      "length": _vm.totalPages,
      "total-visible": _vm.pagesVisible
    },
    on: {
      "input": _vm.loadData
    },
    model: {
      value: (_vm.params.page),
      callback: function($$v) {
        _vm.params.page = $$v
      },
      expression: "params.page"
    }
  })], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 838:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(1320),
  /* template */
  __webpack_require__(1643),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 920:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(923),
  /* template */
  __webpack_require__(924),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 922:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(935)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(926),
  /* template */
  __webpack_require__(941),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-21f12c14",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 923:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


function sendValue(value) {
	this.$emit('input', value);
}

function changeValue(value) {
	this.$emit('change', value);
}

/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'select-button',
	inheritAttrs: false,
	methods: {
		changeValue: changeValue,
		sendValue: sendValue
	},
	props: {
		labelText: {
			default: '',
			type: String
		},
		value: null
	}
});

/***/ }),

/***/ 924:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('label', {
    staticClass: "label-form"
  }, [_vm._v(_vm._s(_vm.labelText))]), _vm._v(" "), _c('v-select', _vm._b({
    staticClass: "filter-select filter-select filter-select-autocomplete",
    attrs: {
      "hide-details": "",
      "value": _vm.value,
      "single-line": ""
    },
    on: {
      "input": _vm.sendValue,
      "change": _vm.changeValue
    }
  }, 'v-select', _vm.$attrs, false))], 1)
},staticRenderFns: []}

/***/ }),

/***/ 926:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


function sendDate(value) {
	this.$emit('input', value);
}

function toggleIconProductDate() {
	this.onChangeProduct = !this.createdAt;
}

function changeIconProduct(result) {
	this.onChangeProduct = result;
}

function arrowIconProduct() {
	return this.onChangeProduct ? 'arrow_drop_up' : 'arrow_drop_down';
}

function data() {
	return {
		menu: false,
		onChangeProduct: false
	};
}

/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'select-date',
	computed: {
		arrowIconProduct: arrowIconProduct
	},
	inheritAttrs: false,
	data: data,
	methods: {
		changeIconProduct: changeIconProduct,
		sendDate: sendDate,
		toggleIconProductDate: toggleIconProductDate
	},
	props: {
		bgIconBlue: {
			default: false,
			type: Boolean
		},
		icon: {
			default: '',
			type: String
		},
		labelText: {
			default: '',
			type: String
		},
		value: {
			default: null
		}
	}
});

/***/ }),

/***/ 932:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(772)(true);
// imports


// module
exports.push([module.i, ".main[data-v-21f12c14]{width:100%}", "", {"version":3,"sources":["/opt/build/repo/src/clerkinn/shared/select-date.vue"],"names":[],"mappings":"AACA,uBACE,UAAY,CACb","file":"select-date.vue","sourcesContent":["/*-----------------------------------------------------------------------------*/\n.main[data-v-21f12c14] {\n  width: 100%;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 935:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(932);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(773)("5462be31", content, true);

/***/ }),

/***/ 941:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main"
  }, [_c('label', {
    staticClass: "label-form"
  }, [_vm._v(_vm._s(_vm.labelText))]), _vm._v(" "), _c('v-menu', {
    staticClass: "menu-date-picker",
    attrs: {
      "lazy": "",
      "offset-y": "",
      "full-width": "",
      "transition": "scale-transition",
      "max-width": "290px",
      "nudge-left": 40
    },
    on: {
      "input": _vm.changeIconProduct
    },
    model: {
      value: (_vm.menu),
      callback: function($$v) {
        _vm.menu = $$v
      },
      expression: "menu"
    }
  }, [_c('v-text-field', _vm._b({
    class: [_vm.bgIconBlue ? 'product-date-picker' : null],
    attrs: {
      "readonly": "",
      "single-line": "",
      "hide-details": "",
      "prepend-icon": _vm.icon,
      "label": _vm.labelText,
      "append-icon": _vm.arrowIconProduct,
      "append-icon-cb": _vm.toggleIconProductDate,
      "value": _vm.value
    },
    on: {
      "input": _vm.sendDate
    },
    slot: "activator"
  }, 'v-text-field', _vm.$attrs, false)), _vm._v(" "), _c('v-date-picker', _vm._b({
    attrs: {
      "no-title": "",
      "scrollable": "",
      "value": _vm.value
    },
    on: {
      "input": _vm.sendDate
    }
  }, 'v-date-picker', _vm.$attrs, false))], 1)], 1)
},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/47.653e70077d466ddf4595.js